export default __webpack_public_path__ + "static/media/beep-1.3691792e.ogg";